import { render, staticRenderFns } from "./SnapsheetsTemplatesItem.vue?vue&type=template&id=b9493108&scoped=true&"
import script from "./SnapsheetsTemplatesItem.vue?vue&type=script&lang=js&"
export * from "./SnapsheetsTemplatesItem.vue?vue&type=script&lang=js&"
import style0 from "./SnapsheetsTemplatesItem.vue?vue&type=style&index=0&id=b9493108&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9493108",
  null
  
)

export default component.exports